import styles from '@components/components/CmsComponents/components/CmsDynamicIframe/CmsDynamicIframe.module.scss';
import Container from '@components/components/Container/Container';
import { urlRegex } from '@components/utils';
import React, { useState, useRef, useMemo, useEffect } from 'react';
import classNames from 'classnames';
import { Skeleton } from '@wienenergiegithub/ui-next';

export const getUrl = ({ url, queryString }) => {
  const urlParams = new URLSearchParams(queryString);

  return url.replace(urlRegex, match => {
    const [key, value] = match.substr(1).split('=');
    const currentValue = urlParams.get(key);

    if (value === 'optional' && !currentValue) {
      return '';
    }

    if (currentValue) {
      return `${match[0]}${key}=${currentValue}`;
    }

    return match;
  });
};

const CmsDynamicIframe = ({
  url,
  description,
  fallbackHeight,
  origin,
  offset = 32,
}) => {
  const [hasIframeLoaded, setHasIframeLoaded] = useState(null);
  const [iframeHeight, setIframeHeight] = useState(0);
  const iframeRef = useRef(null);
  const dynamicUrl = useMemo(
    () => getUrl({ url, queryString: window.location.search }),
    url,
  );

  const readMessage = event => {
    if (
      typeof event.data !== 'string' ||
      Number.isNaN(event.data.split('height:')[1]) ||
      !origin.includes(event.origin)
    ) {
      return;
    }

    setIframeHeight(parseInt(event.data.split('height:')[1], 10) + offset);
  };

  useEffect(() => {
    window.addEventListener('message', readMessage);

    return () => {
      window.removeEventListener('message', readMessage);
    };
  }, []);

  const handleFrameLoad = () => {
    setHasIframeLoaded(true);
  };

  return (
    <div>
      {hasIframeLoaded === null && (
        <Container>
          <div
            style={{
              display: 'grid',
              gap: '20px',
              gridTemplateColumns: '1fr',
            }}
          >
            <Skeleton count={1} height="400px" />
          </div>
        </Container>
      )}
      <Container>
        <iframe
          className={classNames(styles.container, {
            [styles.loaded]: hasIframeLoaded,
          })}
          height={`${iframeHeight || fallbackHeight}px`}
          onLoad={handleFrameLoad}
          ref={iframeRef}
          sandbox
          src={dynamicUrl}
          title={description}
          width="100%"
        />
      </Container>
    </div>
  );
};

CmsDynamicIframe.noMargin = true;
CmsDynamicIframe.size = 'full';

export default CmsDynamicIframe;
